export const TWC_AIFC_ENTRY_POINT = 'twc-aifc-onboarding';

export const TWC_AIFC_ELIGIBLE_EDITIONS = ['standard', 'premium'] as const;

export const isTwcEditionEligibleForAifc = (edition: string | undefined | null): boolean =>
	typeof edition === 'string' &&
	(TWC_AIFC_ELIGIBLE_EDITIONS as readonly string[]).includes(edition);
